<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_BatchEditEnterpriseWechat')"
      width="950px"
      :close-on-click-modal="false"
      custom-class="edit-enterprise-wechat"
    >
      <div class="app-main-inner-row">
        <div class="filters" style="display: inline;width: 600px;">
          <el-form :inline="true" label-width="80px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_ContactName')">
              <el-input v-model="filter.contactPerson" no="contactPerson" />
            </el-form-item>
            <el-form-item :label="$t('baseInfo.partner.companyName')">
              <el-input v-model="filter.companyName" no="companyName" />
            </el-form-item>
            <el-form-item :label="$t('Payment.businessType')">
              <el-select v-model="filter.lob" no="lob" multiple collapse-tags>
                <el-option
                  v-for="(item,index) in lobs"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="triggers">
          <el-button no="toQuery" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>&nbsp;
          <el-button no="showEditDialog" type="primary" @click="showEditDialog">{{ $t('CargoMsg.Cargo_EditEnterpriseWechatButton') }}</el-button>&nbsp;
        </div>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:400px;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
        <cargo-pagination
          v-show="total>0"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_EditEnterpriseWechatTitle')"
      width="400px"
      :close-on-click-modal="false"
      top="20vh"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="80px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_RpaAccount')" label-width="120px">
            <el-input v-model="editDialog.rpaAccount" no="rpaAccount" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_WechatGroupName')" label-width="120px">
            <el-input v-model="editDialog.wechatGroupName" no="wechatGroupName" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as CargoOfRoleTypeUtil from '@/class/cargo/model/utils/CargoOfRoleTypeUtil'
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryEnterpriseWechatContact, updateEnterpriseWechatContact } from '@/api/partner/contact'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { deepClone } from '@/utils'

export default {
  name: 'EditEnterpriseWechat',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, default: () => false },
    checkHQReadOnlyPermission: { type: Function, required: true }
  },
  data() {
    return {
      innerVisible: false,
      lobs: [],
      roleTypes: [],
      selectTypeNames: TYPE_NAMES,
      filter: {
        companyName: '',
        currentBranchId: '',
        branchId: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true, pinned: 'left', sortable: false,
          suppressMenu: true, suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('Partners.partnerAbbreviation'), field: 'companyName', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('SeaExport.ChargeBranchId'), field: 'branchId', initialWidth: 110, minWidth: 110,
          cellRenderer: params => {
            if (params.value === 1) {
              return 'HQ'
            }
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
            return value || params.value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactPerson', initialWidth: 100, minWidth: 100 },
        { headerName: this.$t('Payment.businessType'), field: 'lob', initialWidth: 200, minWidth: 200,
          cellRenderer: params => {
            return params.value ? ColumnUtils.fbaIeJobsLabelFunc(params.value.split(',')) : params.value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RpaAccountColumn2'), field: 'rpaAccount', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_WechatGroupName'), field: 'wechatGroupName', initialWidth: 150, minWidth: 150 }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false,
        rpaAccount: '',
        wechatGroupName: '',
        companyUuids: []
      }
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.filter = this.filterInit()
        this.rowData = []
        this.total = 0
      }
    }
  },
  async created() {
    this.lobs = SystemConstants.LOBS
    this.roleTypes = CargoOfRoleTypeUtil.getRoleTypes()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    toQuery() {
      const currentOffice = this.$store.getters.currentOffice
      this.filter.currentBranchId = currentOffice.officeId
      if (currentOffice.code !== 'HQ') {
        this.filter.branchId = currentOffice.officeId + ',1'
      }
      const data = deepClone(this.filter)
      if (this.filter.lob) {
        data.lob = this.filter.lob.join(',')
      }
      this.loading = getLoading()
      queryEnterpriseWechatContact(data).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    showEditDialog() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(rows)
      if (!checkHQReadOnly) {
        return
      }
      this.editDialog.companyUuids = []
      for (const item of rows) {
        if (!this.editDialog.companyUuids.includes(item.companyUuid)) {
          this.editDialog.companyUuids.push(item.companyUuid)
        }
      }
      this.editDialog.rpaAccount = ''
      this.editDialog.wechatGroupName = ''
      this.editDialog.visible = true
    },
    async save() {
      if (!this.editDialog.rpaAccount || !this.editDialog.wechatGroupName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RpaAccountWechatGroupNameCanTBeEmpty'))
        return
      }
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows) {
        this.$message.warning(this.$t('Partners.selectAContact'))
        return
      }
      const flag = await this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureModifyRuleConfigTips'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }

      const obj = {}
      obj.uuids = rows.map(row => row.uuid)
      obj.rpaAccount = this.editDialog.rpaAccount
      obj.wechatGroupName = this.editDialog.wechatGroupName
      obj.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      updateEnterpriseWechatContact(obj).then(res => {
        this.editDialog.visible = false
        if (res.data) {
          this.$message.success(this.$t('common.tips.saveSuccess'))
          this.toQuery()
          // this.$emit('callback', this.editDialog.companyUuids)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    filterInit() {
      return {
        contactPerson: '',
        companyName: '',
        currentBranchId: '',
        branchId: '',
        pageNum: 1,
        pageSize: 50
      }
    }
  }
}
</script>
<style lang="scss">
.edit-enterprise-wechat {
  .el-dialog__body {
    padding: 10px !important;
  }
}
</style>
